import { useTranslations } from "../../lib/translations"

export function MemoryTab({ agent }) {
  const t = useTranslations()
  // M2.6 placeholder. M2.9 wires Anthropic Memories list/read into a
  // tree browser here.
  return (
    <div className="cm-tabwrap">
      <div className="cm-coming-soon">
        {t("modal.memory.coming_soon")}
        {agent.anthropic_agent_id && (
          <>
            <br /><br />
            <code style={{ fontFamily: "Space Mono", fontSize: 11 }}>
              memory_store_id = {agent.anthropic_agent_id}
            </code>
          </>
        )}
      </div>
    </div>
  )
}
